import type { ServicesConfigValues } from '@/core/types';

export const SERVICES_CONFIG: ServicesConfigValues = {
  niche_and_trend_analyses: {
    url: '/services/analytics/niche-analysis/',
  },
  return_rate: {
    url: 'services/analytics/returns-analysis/',
  },
  description_generator: {
    url: '/services/promotion/description-generation/',
  },
  seo_keyword: {
    url: '/services/promotion/seo-optimization/',
  },
  order_assembly: {
    url: '/services/orders/order-assembly/',
  },
  stock_forecasting: {
    url: '/services/orders/stock-forecast/',
  },
  review_ai_answer: {
    url: '/services/orders/auto-reviews/',
  },
  auto_discount: {
    url: '/services/promotion/auto-pricing/',
  },
};
